import axios from 'axios';
import { clearSession } from './session';

const API_URL = window.__ENV__?.REACT_APP_API_URL || process.env.REACT_APP_API_URL || 'http://localhost:20002';

// ISS-069 — refresh 단일화.
// 토큰 만료 시 대시보드의 폴링 호출 다수가 동시에 401 → 각자 /auth/refresh 를 호출하면
// refresh stampede 가 발생한다. in-flight Promise 를 공유해 동시 호출을 1회로 합친다.
let inFlight: Promise<string> | null = null;

/**
 * refresh_token 으로 access_token 을 재발급한다.
 * - 진행 중인 refresh 가 있으면 그 Promise 를 그대로 반환한다 (뮤텍스).
 * - 성공 시 localStorage 갱신 + `auth:token-refreshed` 이벤트 발행 → AuthContext/SSEContext 동기화.
 * - 실패 시 세션을 폐기하고 에러를 그대로 throw 한다 (호출자가 리다이렉트/중단 처리).
 */
export function refreshAccessToken(): Promise<string> {
  if (inFlight) return inFlight;

  const refreshToken = localStorage.getItem('refresh_token');
  if (!refreshToken) {
    return Promise.reject(new Error('no_refresh_token'));
  }

  inFlight = axios
    .post(`${API_URL}/api/v1/auth/refresh`, { refresh_token: refreshToken })
    .then((res) => {
      const { access_token, refresh_token, role } = res.data as {
        access_token: string;
        refresh_token: string;
        role?: string;
      };
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('refresh_token', refresh_token);
      if (role) localStorage.setItem('role', role);
      // ISS-069 — AuthContext state(=SSEContext 의 토큰 소스)가 최신값으로 동기화되도록 통지.
      window.dispatchEvent(
        new CustomEvent('auth:token-refreshed', { detail: { access_token, role } }),
      );
      return access_token;
    })
    .catch((err) => {
      // refresh 실패 = 세션 복구 불가 (refresh 만료 / 절대 수명 초과 / SESSION_REPLACED).
      clearSession();
      throw err;
    })
    .finally(() => {
      inFlight = null;
    });

  return inFlight;
}
